

import PropTypes from 'prop-types';

import useTranslations from "../../../providers/useTranslations";

import  { capitalize } from "../../../lib/utils";

function ChooseAddressCard(props) {

  const { address, agentId, location, barrios } = props

  const { tr /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  React.useEffect(() => {

    // if there is no barrio - get the barrio list from the agent barrio_costs
    // agentId
    if (!address.barrio || address.barrio === "" ) {

    }

    //console.log("ChooseAddressCard - useEffect - address", address, barrios)
  }, [address]);


  const addressLine = () => {
    if (address.address && address.barrio && address.city) {
      return address.address + ', (' + address.barrio + '), ' + address.city
    } if (address.address && address.city) {
      return address.address + ', ' + address.city
    }
    return ''
  }

  const chooseBarrio = () => {
    //console.log("ChooseAddressCard - chooseBarrio - barrios", barrios)
    return <div>
      <select
        className="form-control"
        value={address.barrio}
        onChange={(e) => {
          props.onBarrioChange(e.target.value)
        }}
      >
        <option value="">Eligir Barrio</option>
        {barrios.map((barrio) => {
          return <option key={barrio} value={capitalize(barrio)}>
            {capitalize(barrio) }</option>
        })}
      </select>
    </div>
  }

  const chooseAddressButton = () => {
    // we can only show the choose barrio selector if there are barrios to choose from
    if ((!address.barrio || address.barrio == "") && barrios.length > 0 && location.flags && location.flags.includes("barrioPricing")){
      return chooseBarrio()
    }
    //console.log("ChooseAddressCard - has barrio - address", address)
    return <button className="btn btn-sm btn-success mr-2" onClick={props.onDeliverHereClick}> {tr("DELIVER HERE")} </button>
  }

  return (
    <div className={"bg-white addresses-item mb-4 card " + (props.boxClass)}>
      <div className="gold-members p-4">
        <div className="media" >
          <div className="mr-3"><i className={"icofont icofont-"+props.icoIcon + ' ' + props.iconclassName} /></div>
          <div className="media-body">
            <h6 className="mb-1 text-secondary">{props.title}  </h6>
            <div className="text-black">{address.name}</div>
            <div className="text-black">{address.phone}</div>
            <p className="text-black">{addressLine()}</p>
            {address.instructions &&
              <p className="text-black">{address.instructions}</p>
            }

            <div className="mb-0 text-black font-weight-bold">
              {props.type === "hasAddress" ?
                (<div style={{
                  display: 'flex',
                  justifyContent: 'space-between'
                }}

                >

                  {chooseAddressButton()}

                  <span
                    onClick={props.onDelete}

                  ><i className="icofont icofont-trash icofont-2x" /></span>
                  {/* time to deliver to this address  <span>30MIN</span>   */}

                </div>)
                : <button className="btn btn-sm btn-primary mr-2"  onClick={props.onAddNewClick}> {tr("ADD NEW ADDRESS")} </button>
              }
            </div>
          </div>
        </div >
      </div>
    </div>
  );
}

ChooseAddressCard.propTypes = {
  title: PropTypes.string.isRequired,
  icoIcon: PropTypes.string.isRequired,
  iconclassName: PropTypes.string,
  address: PropTypes.object,
  onDeliverHere: PropTypes.func,
  onAddNewClick: PropTypes.func,
  type: PropTypes.string.isRequired
};

ChooseAddressCard.defaultProps = {
  type: 'hasAddress'
}


export default ChooseAddressCard;
